import React from 'react';
import {useLocation, useNavigate} from "react-router";

import Stack from '@mui/joy/Stack';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';
import Sheet from '@mui/joy/Sheet';

import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

import {stopData} from "./stopData.js";

/*
function getSMA20(quotes) {
	var i;
	var stop;
	var sma20 = 0;
	var copy = [...quotes];
	
	copy.reverse();
	
	stop = Math.min(copy.length, 20);
	
	for (i = 0; i < stop; ++i) {
		sma20 = sma20 + copy[i].close;		
	}

	return (sma20 / 20).toFixed(2);
}


function getATR14(quotes) {
	var i;
	var start;
	var atr14 = 0;
	var prevClose = 0;
	var firstQuote = true;
	
	start = quotes.length - 14;
	
	for (i = start; i < quotes.length; ++i) {
					
		if (firstQuote) {
			firstQuote = false;
			atr14 = quotes[i].high - quotes[i].low;
		}
		else {
			atr14 = atr14 + Math.max(quotes[i].high - quotes[i].low, Math.abs(quotes[i].high - prevClose), Math.abs(quotes[i].low - prevClose));						
		}
		
		prevClose = quotes[i].close;
	}
	
	return (atr14/14).toFixed(2);
}
*/

function ShowStock () {	
	const {state} = useLocation();
	const navigate = useNavigate();
	const [buyPrice, setBuyPrice] = React.useState('');
	const [isDisabled, setDisabled] = React.useState(true);
	
	function setStop() {
		stopData.stock.buyprice = buyPrice;
		navigate('/setstop', {state: buyPrice});
	}
	
	var quotes = [];
	var categories = [];	

	state.quotes.forEach((key, index) => {
		quotes[index] = key.close;
		var dt = new Date(key.date);
		categories[index] = dt.getDate() + ' ' + dt.toLocaleString('default', { month: 'short' });
	});
	
	stopData.stock.stockname 	= state.name;
	stopData.stock.ticker 		= state.code;
	//stopData.stock.SMA200 		= state.summaryDetail.twoHundredDayAverage;
	stopData.stock.SMA50 		= state.misc.sma50;
	stopData.stock.SMA20 		= state.misc.sma20;
	stopData.stock.ATR			= state.misc.atr14;
	stopData.stock.marketprice  = state.close;

	// Highcharts template
	const config = {	
		accessibility: {
			enabled: false,
		},
		title: {
			text: state.name,
			style: {
				color: "rgba(255,255,255, 0.87)",
				fontSize: "2em"
        	}
		},
		subtitle: {
	  		text: state.close + ' ' + state.currency,
			style: {
				color: "rgba(255,255,255, 0.6)",
				fontSize: "1.2em"
			}
		},

	  chart: {
	  	type: 'area',
	    height: (9 / 16 * 100) + '%',
	    panning: false,
	    backgroundColor: "#2b353e"
	  },

		plotOptions: {
			series: {
				allowPointSelect: false,
				enableMouseTracking: false,
				color: "#48DE94",
				fillOpacity: 0.1
			},
			area: {
				fillColor : {
				   linearGradient : {x1: 0, y1: 0, x2: 0, y2: 1},
				   stops : [ [0, Highcharts.Color('#48DE94').setOpacity(0.65).get("rgba")], [1, Highcharts.Color('#2b353e').setOpacity(0.35).get("rgba")]],
				},				
			}
		},

		rangeSelector: {
			enabled: false
		},

		navigator: {
			enabled: false
		},

	  tooltip: {
	    enabled: true
	  },

      scrollbar: {
      	enabled: false
      },
      
	yAxis: {
		title: {
			text: null
		}
    },

	xAxis: {
	  type: 'datetime',
	  categories: categories,	  			  
	  dateTimeLabelFormats: {
	        day: '%Y<br/>%m-%d'
	  }
	},

    series: [
      	{
	        marker: {
	            enabled: false
	        },	    
            id: 'STOCK',
            type: 'area',
            showInLegend: false,
            data: quotes,
    	}
    ]

    };
   
   	// Show a tighter interval to avoid a to "flat" line (else y-axis starting at zero)
	config.yAxis.min = Math.min(...quotes);
	config.yAxis.max = Math.max(...quotes);
   
    
    function handleEnter(e) {
        if (e.key == "Enter" && !isDisabled)
	        setStop();	    
    }
    
	function handleKeyPress(event) {

	    if (event.value[event.value.length-1] == ',') {
			event.value = event.value.slice(0, event.value.length-1) + '.';
	    }
	
        if (isNaN(event.value)) {
	        event.value = event.value.slice(0, event.value.length-1);
        }
        
		setDisabled(event.value.length == 0);        
        
        setBuyPrice(event.value);
                
	}    
	
	return (
		<React.Fragment>
			<Stack direction="row" justifyContent="center" sx={{py: 1.5}}>
				<Sheet style={{ backgroundColor: '#2b353e' }} sx={{ px: 3, py: 1.5, borderRadius: 'lg' }}>
		    		<HighchartsReact highcharts={Highcharts} options={config}></HighchartsReact>		    		
		    	</Sheet>
		    </Stack>		
	
			<Stack direction="row" spacing={1} justifyContent="center">
				<Input autoFocus id="buyPriceInput" size="lg" placeholder="Your buy price" onChange={(e) => {handleKeyPress(e.target);}} onKeyPress={handleEnter} />
				<Button size="lg" onClick={setStop} disabled={isDisabled} endDecorator={<KeyboardArrowRight />}>
					Show stops
				</Button>
			</Stack>
		</React.Fragment>		
	);
}

export default ShowStock;